import { render } from "./TasksPage.vue?vue&type=template&id=77fbda2d&scoped=true&ts=true"
import script from "./TasksPage.vue?vue&type=script&lang=ts"
export * from "./TasksPage.vue?vue&type=script&lang=ts"

import "./TasksPage.vue?vue&type=style&index=0&id=77fbda2d&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77fbda2d"]])

export default __exports__